import React from 'react';

import clsxm from '@/lib/clsxm';

const Loader: React.FC = () => {
  return (
    <div className={clsxm(`flex h-full w-full items-center justify-center`)}>
      <div className='relative inline-block h-[20px] w-[20px]'>
        <div
          className={clsxm(
            'h-[20px] w-[20px] border-3 border-solid border-transparent border-t-ds-purple-600',
            'animate-lds-ring animation-delay-450 absolute box-border block rounded-[50%]'
          )}
        />
        <div
          className={clsxm(
            'h-[20px] w-[20px] border-3 border-solid border-transparent border-t-ds-purple-600',
            'animate-lds-ring animation-delay-300 absolute box-border block rounded-[50%]'
          )}
        />
        <div
          className={clsxm(
            'h-[20px] w-[20px] border-3 border-solid border-transparent border-t-ds-purple-600',
            'animate-lds-ring animation-delay-150 absolute box-border block rounded-[50%]'
          )}
        />
        <div
          className={clsxm(
            'h-[20px] w-[20px] border-3 border-solid border-transparent border-t-ds-purple-600',
            'animate-lds-ring absolute box-border block rounded-[50%]'
          )}
        />
      </div>
    </div>
  );
};

export default Loader;
